import angular from 'angular';

import component from './product-details.component';

const ProductDetails = angular
    .module('control-room.menus.components.product-details', [])
    .component('crProductDetails', component);

export default ProductDetails;
